// angular
// 	.module("HeroPRO")
// 	.directive('hpSpinnerLink', spinnerLink);


import './spinnerLink.scss';

export default function spinnerLink() {
    return {
        restrict: 'E',
        scope: {
            linkFn: '&?',
            linkText: '@',
            linkUrl: '=',
            displaySpinner: '=',
            icon: '@',
        },
        templateUrl: 'app/common/controls/spinnerLink/spinnerLink.html',
    };
}



// WEBPACK FOOTER //
// ./src/app/common/controls/spinnerLink/spinnerLinkDirective.js